mutation CreatePlatformCustomCover($input: CreatePlatformCustomCoverInput!) {
  createPlatformCustomCover(input: $input) {
    id
    title {
      text
      color
      size
      weight
    }
    subTitle {
      text
      color
      size
      weight
    }
    buttons {
      text
      link
      variant
      disabled
    }
    buttonsColor
    buttonsSize
    brightness
    background {
      mobileImageId
      desktopImageId
      mobileVideoId
      desktopVideoId
    }
    align
    alignMobile
    verticalAlign
    verticalAlignMobile
    publishAt
    createdAt
    updatedAt
  }
}

